// FAQ.js
import React, { useState } from "react";
import "./Faq.css";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Divider from "@mui/material/Divider";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faqData = [
  {
    question: "What is NoSelfiee?",
    answer:
      "NoSelfiee connects you with nearby photographers to capture your special moments",
  },
  {
    question: "Can I view photographer portfolios before booking?",
    answer:
      "Yes, you can view the portfolios of the near by photographers available before booking.",
  },
  {
    question: "What if I need to cancel my booking?",
    answer: "You can cancel your booking anytime using the cancel button.",
  },
  {
    question: "How does payment work on NoSelfiee?",
    answer: "You can pay online or cash on completing the service.",
  },
  {
    question: "Are the photographers on NoSelfiee vetted for quality",
    answer:
      "Yes, we ensure that all photographers listed on No selfiee are vetted for quality and professionalism. We review their portfolios and customer feedback to maintain high standards of service.",
  },
  {
    question:
      "Is there customer support available if I have questions or issues?",
    answer:
      "Yes, you can contact our support team via chat, email or call using NoSelfiee app.",
  },

  {
    question: "What happens if the mobile photographer is running late?",
    answer:
      "We make every effort to guarantee our partners arrive to our customers on schedule. However, if there are any delays, please contact us by phone, chat, or email, and we will assist you by offering you a different mobile photographer.",
  },
  {
    question: "What is the business plan of NoSelfiee?",
    answer:
      "An online business called NoSelfiee cater to mobile photographers.These freelance mobile photographers either work for an operator who owns several mobile photographers or are self-employed and operate their own commercial mobile photographers.These mobile photographers have a mobile app on their phones that works similarly to the NoSelfiee app that you use to book a mobile photographer. After carefully verifying the app's legitimacy and doing due diligence on the mobile photographer's and operator's personal and business documents, we activate the app. These mobile photographers schedule their own login times to use the NoSelfiee app and take client session requests. Users have the option to stay logged out of the system for their own convenience.",
  },
  {
    question: "What is the peak time charge for NoSelfiee?",
    answer:
      "A fare-rationalizing rule known as NoSelfiee peak time charge uses a multiplier X or a flat surcharge to standard fares, making the fare higher than the standard fare during specific times of the day. For example, if X is 1.2 at a given time, the standard fare will be multiplied by 1.2 to get the final fare.      ",
  },
  {
    question: "Why is adding a premium to my regular fare necessary?",
    answer:
      "As a marketplace, NoSelfiee has no control over how many mobile photographers are active on its system or platform; photographers and operators are free to work whenever it suits them. Pulling the supply side of mobile photographers doesn't require extra work on a typical day when demand and supply are met.Because there is little motivation for regular mobile photographers to put in extra effort, NoSelfiee has seen that during particular times of the day when there is more traffic on the roads, they frequently log out of the system to suit their convenience. In a similar vein, there may not be enough mobile photographers on the road when demand spikes. It could be inconvenient for customers to be unable to locate mobile photographers at such times. NoSelfiee's alternatives for encouraging mobile photographers and meeting the demands of high demand times and circumstances are limited as a system/solutions supplier. NoSelfiee has seen that mobile photographers are extremely sensitive to even little increases in compensation for the extra work they put in to keep their accounts active. NoSelfiee adds a flat fee or an X multiplier to the standard fare depending on a number of variables, including the location and time of the session, the kind of mobile photographer, the supply and demand conditions, etc. With the use of sophisticated analytics, a proprietary algorithm, historical session data, and other factors, the NoSelfiee program determines how much to charge in addition to the standard rate. This makes it possible for NoSelfiee to devise suitable rewards for mobile photographers in order to encourage people to continue using the app and earning more money. This makes it possible for clients to receive their much-needed service even during periods of strong demand for mobile photographers. The peak time surcharge has two main effects: a) It encourages mobile photographers to stay and work longer, especially during challenging times of the day and during periods of high demand. b) It eliminates the sessions that aren't as necessary, freeing up the mobile photographer for people who actually need one.",
  },
];

const FAQ = () => {
  const [expanded, setExpanded] = useState(null);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
  };
  return (
    <div className="container">
      <Container>
        <Typography variant="h4" gutterBottom>
          Frequently Asked Questions
        </Typography>
        <Divider orientation="vertical" variant="middle" flexItem />

        {faqData.map((item, index) => (
          <>
            <Accordion
              key={index}
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{item.question}</Typography>
              </AccordionSummary>
              <AccordionDetails
                style={{
                  // display: "flex",
                  flexDirection: "column",
                  alignContent: "left",
                  justifyContent: "left",
                }}
              >
                <Typography>{item.answer}</Typography>
              </AccordionDetails>
            </Accordion>
            <Divider orientation="vertical" variant="middle" />
          </>
        ))}
        <Divider orientation="vertical" variant="middle" flexItem />
      </Container>
    </div>
  );
};

export default FAQ;
